<template>
  <div class="traffic_info">

    <div class="traffic_info__header">
      <h4 class="title">
        {{ translate("simcard_devices.traffic") }}
      </h4>
    </div>

    <div class="cards">
      <div class="traffic_info__card"
           v-for="(traffic, traffic_key) in traffic_info"
           :key="traffic_key"
      >
      <div class="card_title">
        <p>
          {{ traffic.slot }}
          {{ traffic.mno }}
          {{ traffic_key }}
          {{ traffic.iccid }}
        </p>

        <p>
          {{ traffic.summary_hint}}
        </p>

        <p>
          {{ traffic.summary }}
        </p>
      </div>

        <div class="content">
          <div
            class="content-item"
            v-for="(item, key) in traffic"
            :key="traffic_key + '' + key"
            v-if="(key.indexOf('-') > -1)"
          >
            <div class="left">
              <span class="title">{{ key }}</span>
            </div>
            <div class="right">
              <span class="title">{{ item }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom">
      <span
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="close"
      >
        {{ translate("close_modal") }}
      </span>
    </div>
  </div>
</template>
<script>

export default {
  name: "SimcardTrafficInfo",
  props: ["traffic_info"],
  data() {
    return {

    };
  },

  methods: {
    close() {
      this.$emit("close");
    },

  },
};
</script>

<style lang='scss' scoped>
.traffic_info {
  padding: 10px;
  &__header{
    margin-bottom: 10px;
    .title{
      text-align: center;
      margin-bottom: 0;
      margin-top: 0;
    }
  }

  .cards{
    height: 500px;
    overflow: auto;
  }

  &__card{
    box-shadow: 0 2px 2px #ccc5b980;
    color: #252422;
    position: relative;
    border: 1px solid #ccc;
    min-height: 85px;
    background-color: #f8f8f8;
    margin-bottom: 10px;
    .card_title{
      display: block;
      text-align: center;
      padding: 5px;
      background-color: #efe9e9;
      border-bottom: 1px solid #ccc;
      p{
        margin-bottom: 0;
        font-size: 14px;
      }
    }
    .content {
      font: 300 12px/16px "Roboto", Arial, sans-serif;
      text-align: center;
      display: flex;
      flex-direction: column-reverse;
      .content-item{
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding: 5px;
        &:nth-child(2n+1) {
          background-color: #e2ecdc;
        }
        .left{
          width: 40%;
        }
        .right{
          width: 60%;
        }
        div{
          display: flex;
          align-items: center;
          justify-content: flex-start;
          font-size: 12px;
          height: 100%;
          span{
            text-overflow: ellipsis;
          }
        }
      }
    }
    &_footer {
      text-align: center;
      padding: 15px 0 5px;
      border-top: 1px solid #ccc;
    }
  }

  .bottom {
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .btn {
      margin: 0 5px;
      display: block;
    }
  }
}
</style>
